export default __webpack_public_path__ + "static/media/aboutCat2XXS.8e528c31.webp";